import { useEffect, useState } from 'react';
import { validate as uuidValidate } from 'uuid';

import * as gatewayService from '@frolight/services/api/gatewayService';
import HTTPStatusError from '@frolight/utils/HTTPStatusError';

const useGatewayData = (registrationCode) => {

  const [ loading, setLoading ] = useState(true);
  const [ data, setData ] = useState(null);
  const [ error, setError ] = useState(null);

  useEffect(() => {

    let mounted = true;

    const getGatewayAbortController = new AbortController();
    const getGateway = async () => {
      mounted && setLoading(true);

      try {
        if (uuidValidate(registrationCode)) {
          const fetchedGateway = await gatewayService.getGatewayByRegistrationCode(
            getGatewayAbortController,
            { registrationCode }
          );
          if (fetchedGateway) {
            mounted && setData(fetchedGateway.data);
          } else {
            mounted && setError({ type: 'INVALID_REGISTRATION_CODE '});
          }
        } else {
          mounted && setError({ type: 'INVALID_REGISTRATION_CODE '});
        }
      } catch (err) {
        if (err.name !== 'AbortError') {
          if (err instanceof HTTPStatusError) {
            if (err.errorCode === 404) {
              mounted && setError({ type: 'INVALID_REGISTRATION_CODE '});
            } else {
              mounted && setError(err);
            }
          } else {
            mounted && setError(err);
          }
        }
      } finally {
        mounted && setLoading(false);
      }
    };

    if (registrationCode) {
      setError(null);
      getGateway();
    }

    return () => {
      mounted = false;
      getGatewayAbortController.abort();
    }

  }, [ registrationCode ]);

  return { loading, error, data };

};

export default useGatewayData;
